import * as THEME from "../../themes/colors";
var getFlexStyleForColumn = function (column, config) {
    var flexValue = "0 0 " + config.width + "px";
    var style = {
        flex: flexValue,
        msFlex: flexValue,
        WebkitFlex: flexValue,
        overflow: 'hidden'
    };
    // TODO: Need to fix (https://prgtfs01.amust.local/DefaultCollection/UIKit/_workitems/edit/254663)
    if (column.props.totalColumn && config.isHeaderCell) {
        Object.assign(style, {
            display: 'flex',
            height: '100%',
            alignItems: 'center',
            justifyContent: 'flex-end',
            backgroundColor: config.disabled
                ? THEME.blue.colorBackgroundNeutralLight
                : THEME.blue.colorHighlightNotification
        });
    }
    return style;
};
export default getFlexStyleForColumn;
//# sourceMappingURL=getFlexStyleForColumn.js.map